import { FaxRxComposite } from "@/Common/Api/Pharmacy/Dto/Responses/FaxRxComposite";
import { IPharmacyInfo } from "./IPharmacyInfo";

class MedfarDictionariesPharmacy implements IPharmacyInfo {
    public Id: string = "";
    public Name: string = "";
    public Phone: string = "";
    public Address: string = "";
    public Fax: string = "";
    public Banner: string = "";
}

class Pharmacy implements IPharmacyInfo {
    public Name: string = "";
    public Phone: string = "";
    public Address: string = "";
    public Fax: string = "";
    public Banner: string = "";

    public constructor(fields?: Partial<Pharmacy>) {
        Object.assign(this, fields);
    }

    public static getFaxComposite(pharmacy: Pharmacy): FaxRxComposite {
        return pharmacy && new FaxRxComposite({
            PharmacyName: pharmacy.Name,
            PharmacyBanner: pharmacy.Banner,
            PharmacyPhone: pharmacy.Phone,
            PharmacyFax: pharmacy.Fax,
            PharmacyAddress: pharmacy.Address
        });
    }

    public static equals(pharmacy1: Pharmacy, pharmacy2: Pharmacy): boolean {
        return pharmacy1.Name === pharmacy2.Name
            && pharmacy1.Banner === pharmacy2.Banner
            && pharmacy1.Phone === pharmacy2.Phone
            && pharmacy1.Fax === pharmacy2.Fax
            && pharmacy1.Address === pharmacy2.Address;
    }
}

export { MedfarDictionariesPharmacy, Pharmacy };
